<template>
  <div class="borderModal">
    <el-dialog :visible.sync="isShowOrderModal" :close-on-press-escape="false" :close-on-click-modal="false"
      width="555px">
      <div class="border">
        <img class="closed" @click="closeModal" :src="closed" alt="" />
        <div class="title">订单确认</div>
        <div class="mobileWrap changeInfo">
          <el-form ref="orderForm" :model="orderForm" :rules="orderFormRules" label-width="100px">
            <el-form-item label="充值账号:" prop="username"><span class="rechargeName">{{
              orderForm.username
            }}</span></el-form-item>
            <el-form-item label="充值金额:" class="telWrap" prop="money"><el-input v-model="orderForm.money"
                :disabled="true" placeholder="请输入充值金额"></el-input></el-form-item>
            <el-form-item label="" label-width="60px" class="Notice" v-if="payParams.money >= 1000">

              <el-checkbox class="checked" v-model="isShowNoticeChecked">允许本次充值信息在游戏内公告展示</el-checkbox>

            </el-form-item>
            <div class="">
              <div class="gitCode">
                可获得：{{ payParams.money }}白金币
                <template v-if="payParams.isFirst"><span style="font-size: 14px">（额外赠送{{ payParams.giftMoney
                    }}绑定白金币）</span></template>
              </div>
              <div class="payBox">
                <p class="center fw500 c3 fs20" style="margin: 15px 0 20px">
                  支付方式选择
                </p>
                <el-radio-group v-model="orderForm.type">
                  <div class="item" v-for="(item, index) in orderPayList">
                    <div class="pic">
                      <img :src="item.picUrl" alt="" @click="payChange(item)" />
                    </div>
                    <el-radio :label="item.name"></el-radio>
                  </div>
                </el-radio-group>
              </div>
            </div>
            <el-form-item class="submitWrapBar">
              <div class="submitWrap">
                <div class="btnWrap" @click="submitForm('orderForm')">
                  <span>{{ isSubmitting ? '处理中…' : '确定充值' }}</span>
                </div>
                <p class="tips">请仔细确认账单后支付！</p>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="wechatPay" v-if="wechatImg">
          <div id="wechatPay"></div>
          <div style="
              display: inline-block;
              width: 300px;
              height: 30px;
              line-height: 30px;
              font-size: 20px;
              color: #333333;
              background: #ffffff;
            ">
            微信扫码支付
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
import eventBus from "@/common/bus.js";

export default {
  name: "pubMask",
  props: {
    isShowOrderModal: false,
    payParams: {},
  },
  data() {
    return {
      userInfo: {
        verifyInfo: {},
        vipInfo: {},
        wallteInfo: {},
      }, // 用户信息

      timer: null,
      firstTimer: null,
      douwCount: 0,
      wechatImg: false,
      isSubmitting: false,
      orderForm: {
        username: "", // 账号
        money: this.payParams.money, // 金额
        type: "2", //支付方式 
      },
      isShowNoticeChecked: true,
      orderPayList: [
        {
          id: "2",
          name: "2",
          picUrl: require("@/assets/imgs/recharge/wechat.png"),
        },
        {
          id: "1",
          name: "1",
          picUrl: require("@/assets/imgs/recharge/alipay.png"),
        },
      ],
      orderFormRules: {
        username: [
          { required: true, message: "请输入充值账号", trigger: "blur" },
        ],
        money: [{ required: true, message: "请输入充值金额", trigger: "blur" }],
      },
      closed: require("@/assets/imgs/public/close.png"),
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.orderForm.username = this.payParams.username || this.userInfo.username;
    if (this.payParams.money < 1000) {
      this.isShowNoticeChecked = false;
    }
  },
  methods: {
    submitForm(orderForm) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$refs[orderForm].validate(async (valid) => {
        if (!valid) {
          this.isSubmitting = false;
          return;
        }
        try {
          if (String(this.payParams.rechargeMode) === "1") {
            try {
              await this.$confirm(
                "您确定选择自定义充值吗？自定义充值可正常获得充值金额对应的白金币，但不享受首充额外赠送的绑定白金币。",
                "自定义充值确认",
                {
                  confirmButtonText: "确认并支付",
                  cancelButtonText: "返回检查",
                  type: "warning",
                  closeOnClickModal: false,
                },
              );
            } catch (_) {
              return;
            }
          }
          await this.goPay();
        } finally {
          this.isSubmitting = false;
        }
      });
    },
    payChange(item) {
      this.orderForm.type = item.name == "2" ? "2" : "1";
    },
    goPay() {
      this.douwCount = 0;
      return axios({
        method: "post",
        url: "/recharge/doPay",
        headers: {
          token: Cookies.get("wx_token"),
        },
        data: {
          money: Number(this.orderForm.money),
          payId: this.orderForm.type, //微信2, 支付宝1
          isShowNotice: this.isShowNoticeChecked?'0':'-1',//是否显示公告的字段
          platForm: "web",
          rechargeId: this.payParams.rechargeId || "99", //充值金额id
          rechargeMode: this.payParams.rechargeMode, //0代表正常充值, 1自定义充值
          userId: Cookies.get("wx_userId"),
          username: this.orderForm.username,
        },
      })
        .then((res) => {
          let that = this;
          if (res.data.state == 200) {
            if (res.data.data.source == "9i173") {
              if (res.data.data.payId == 1) {
                // 支付宝支付
                that.aorderSn = res.data.data.orderSn; //订单id
                // const div = document.createElement('formdiv');
                console.log("9i173", res.data.data.data);

                window.open(res.data.data.data);
              } else {
                // 微信支付
                that.aorderSn = res.data.data.orderSn; //订单id
                that.wechatImg = true;
                setTimeout(() => {
                  var divID = document.getElementById("wechatPay");
                  divID.innerHTML = res.data.data.data;
                }, 100);
              }
            } else {
              if (res.data.data.payId == 1) {
                // 支付宝支付
                that.aorderSn = res.data.data.orderSn; //订单id
                const div = document.createElement("formdiv");
                console.log(res.data.data.data);
                div.innerHTML = res.data.data.data;
                document.body.appendChild(div);
                document.forms["punchout_form"].setAttribute(
                  "target",
                  "_blank",
                );
                document.forms["punchout_form"].submit();
                div.remove();
              } else {
                // 微信支付
                that.aorderSn = res.data.data.orderSn; //订单id
                that.wechatImg = true;
                setTimeout(() => {
                  var divID = document.getElementById("wechatPay");
                  divID.innerHTML = res.data.data.data;
                }, 100);
              }
            }

            that.firstTimer = setTimeout(() => {
              that.timer = setInterval(function () {
                that.queryIsPaySuccess(); // 查询是否支付
              }, 5000);
            }, 10000);
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    queryIsPaySuccess(orderSn) {
      let that = this;
      this.douwCount++;
      if (this.douwCount > 30) {
        window.clearInterval(that.timer); // 清除定时器
        that.timer = null;
        window.clearInterval(that.firstTimer); // 清除定时器
        that.firstTimer = null;
        return false;
      } else {
        axios({
          method: "post",
          url: "/recharge/checkOrder",
          headers: {
            token: Cookies.get("wx_token"),
          },
          data: {
            orderSn: that.aorderSn,
            userId: Cookies.get("wx_userId"),
            platForm: "web",
          },
        })
          .then((res) => {
            if (res.data.state == 200) {
              that.$message.success("支付成功");
              window.clearInterval(that.timer); // 清除定时器
              that.timer = null;
              window.clearInterval(that.firstTimer); // 清除定时器
              that.firstTimer = null;
              that.wechatImg = false;
              setTimeout(() => {
                that.$emit("initData");
              }, 3000);
            }
          })
          .catch((err) => {
            that.$message.error(res.data.message);
          });
      }
    },
    closeModal() {
      let that = this;
      if (this.wechatPay) {
        this.$emit("initData");
      } else {
        window.clearInterval(that.timer); // 清除定时器
        that.timer = null;
        window.clearInterval(that.firstTimer); // 清除定时器
        that.firstTimer = null;
        this.$emit("closeModal");
      }
    },
  },
  watch: {
    payParams(newval) {
      this.orderForm.money = newval.money;
    },
  },
};
</script>

<style lang="less">
.borderModal {
  .center {
    text-align: center;
  }

  .fs20 {
    font-size: 20px;
  }

  .c3 {
    color: #333;
  }

  .fw500 {
    font-weight: 500;
  }

  .el-dialog {
    min-width: 555px;
    background: transparent;

    .rechargeName {
      display: block;
      width: 220px;
      border-bottom: 1px dashed #333333;
    }

    .submitWrapBar {
      margin-top: 20px;
      margin-bottom: 0 !important;

      .el-form-item__content {
        margin-left: 0 !important;
      }

      .submitWrap {
        text-align: center;

        .tips {
          font-size: 12px !important;
          color: #ff0000;
          margin-top: -15px;
        }

        .btnWrap {
          margin: 0 10px;
          display: inline-block;
          padding: 1px;
          width: 170px;
          height: 44px;
          line-height: 42px;
          box-sizing: border-box;
          border-radius: 44px;
          overflow: hidden;

          span {
            display: inline-block;
            width: 100%;
            height: 100%;
            background: linear-gradient(to right, #dd8eff, #ffa3f0);
            border-radius: 46px;
            font-size: 18px;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
          }
        }
      }
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 5px;
      background: linear-gradient(#d7b7ff, #f9f8ff);
      border-radius: 10px;
    }

    .border {
      position: relative;
      z-index: 1;
      padding: 60px 100px;
      background: linear-gradient(#f6f1ff, #d7c5ff);
      border-radius: 10px;
    }

    .closed {
      position: absolute;
      right: -35px;
      top: -38px;
      z-index: 1;
      cursor: pointer;
    }

    .title {
      margin-bottom: 20px;
      text-align: center;
      font-size: 30px;
      color: #333333;
      font-weight: 700;
    }

    .wechatPay {
      width: 100%;
      height: 100%;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.3);

      img {
        margin-top: 110px;
      }
    }

    .el-form-item__label {
      width: 120px;
      font-size: 18px;
      color: #333333;
      font-weight: 700;
      line-height: 36px;

      &:before {
        display: none;
      }
    }

    .el-form-item__content {
      line-height: 36px;
    }

    .el-form-item {
      margin-bottom: 18px !important;
    }

    .el-input {
      height: 36px;
      line-height: 36px;
    }

    .el-input__inner {
      width: 220px;
      height: 36px;
      background: transparent;
      border: 1px solid #333333;
      border-radius: 0;
      padding: 0 6px;

      &::placeholder {
        font-size: 12px;
      }
    }

    .el-input.is-disabled {
      .el-input__inner {
        color: #333333;
      }
    }

    .el-radio-group {
      display: flex;
      justify-content: center;

      .el-radio__label {
        display: none;
      }

      .item {
        width: fit-content;
        margin-right: 20px;
        text-align: center;
        display: flex;
        flex-direction: column;

        .pic {
          margin-bottom: 10px;
        }
      }
    }

    .el-radio__inner {
      width: 20px;
      height: 20px;
    }

    .gitCode {
      width: 350px;
      padding: 0 5px;
      height: 42px;
      margin: 20px auto 0;
      line-height: 42px;
      text-align: center;
      color: #ffffff;
      font-size: 16px;
      background: #a042ff;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
    }
  }

  .Notice {
    .checked {
      .el-checkbox__inner {
        background-color: #ffffff;
        border-color: #dcdfe6;
        /* 保持默认边框，你也可以改成 #9c47fb */
      }

      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #9c47fb !important;
        border-color: #9c47fb !important;
      }

      .el-checkbox__input.is-checked .el-checkbox__inner::after {
        border-color: #ffffff !important;
      }

      .el-checkbox__label {
        color: #000;
      }

    }
  }
}
</style>
